export const specsInfo = {
  allContent: [
    {
      title: "Weather",
      category: "Todos",
      link: "https://369.ad/mediakit/nestle320x480/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Anuncio donde a través de una API se muestra la temperatura de un lugar determinado, destinado, por ejemplo, a empresas de heeladería.",
    },
    {
      title: "Aviador",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/avion/avion/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Rich Media con el objetivo de hacer click cuando el avión pase por el logo de tu empresa.",
    },
    {
      title: "Slider",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/Bipod-acuracy-slide/Bipod-acuracy-slide/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Slides de distintos productos para hacer click en el que elijas.",
    },
    {
      title: "Brackets",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/cup-brackets/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Brackets de torneo deportivo para hacer predicciones del ganador y continuar luego al sitio web a traves del botón de Call to Action.",
    },
    {
      title: "Drink Frost",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/Fernet-branca/Fernet-branca/index.html",
      sizes: "300x600, 320x480",
      height: "484px",
      observations:
        "Rich Media con el objetivo de hacer click repetidas veces en el mismo, para que cada vez se genere mas escarcha, destinado a bebidas o productos de consumo frios.",
    },
    {
      title: "Selector",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/Accuracy-bipod-selector/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Rich Media para seleccionar entre diferentes productos, ver su detalle y hacer click en comprar.",
    },
    {
      title: "Unir los puntos",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/real-state/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Unir los puntos en orden para dibujar una forma en el anuncio, una vez unidos todos los puntos, aparece una imagen a gusto.",
    },
    {
      title: "Live Odds",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/live-odds/live-odds/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Rich media que utiliza APIs para obtener información en tiempo real de estadísticas de partidos y el usuario elige el cuadro que cree va a ganar.",
    },
    {
      title: "Poker",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/poker/poker/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Partida de Poker en la que te encontrás en la mano antes del último flop, apostás all-in y terminás ganando, para continuar a la página.",
    },
    {
      title: "Calculadora de préstamos",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/prestamo/prestamo/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Calculadora de préstamos donde ingresás el monto a solicitar, los meses a pagar y el anuncio te dirá cuanto se debe pagar de intereses por mes.",
    },
    {
      title: "Planes",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/Planes-320X480/Planes-320X480/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Rich Media para financieras donde se ofrece al cliente distintos planes con beneficios dependiendo del plan.",
    },
    {
      title: "Sandwich creator",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/Bimbo/Bimbo/index.html",
      sizes: "300x600, 320x480",
      height: "484px",
      observations:
        "Anuncio destinado principalmente a empresas de comida, en este caso elegir tus condimentos preferidos para tu sandwich preferido.",
    },
    {
      title: "Reproductor MP3",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/MP3/MP3/index.html",
      sizes: "300x600, 320x480",
      observations: "Anuncio de reproductor musical con distintas pistas.",
    },
    {
      title: "Ruleta",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/roulette/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Ruleta de casino en la que hacés click en el boton y ganás para continuar a la página web.",
    },
    {
      title: "Scratch and Reveal",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/Scratch-Te/Scratch-Te/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Anuncio de raspar y revelar un premio o beneficio del otro lado.",
    },
    {
      title: "Memory",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/audimemory/audimemory/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Juego de Memory clásico en el que tenés que unir las mismas imagenes para luego pasar al botón de Call to Action.",
    },
    {
      title: "Vertical scroller",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/adidas/adidas/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Rich Media para seleccionar y desplazarse entre distintos productos.",
    },
    {
      title: "Inbanner",
      category: "Todos",
      link: "https://369.ad/mediakit/armani/index.html",
      sizes: "300x600, 320x480",
      observations: "Rich Media con reproductor de video para eventos y demás.",
    },
    {
      title: "Cubo",
      category: "Todos",
      link: "https://369.ad/mediakit/budcubo2/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Cubo 3D giratorio para colocar 4 imágenes distintas sobre tu empresa/producto.",
    },
    {
      title: "Store locator",
      category: "Todos",
      link: "https://369.ad/mediakit/devoto-santa-monica/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Anuncio basado en mapa con la ubicación de tus tiendas en una región determinada.",
    },
    {
      title: "Countdown",
      category: "Todos",
      link: "https://369.ad/mediakit/miller-countdown-diciembre2020/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Rich Media destinado principalmente a eventos, donde se hace una cuenta regresiva de dicho evento.",
    },

    {
      title: "Cross Slider",
      category: "Todos",
      link: "https://369.ad/mediakit/cross-slider-shell/index.html",
      sizes: "300x600, 320x480",
      height: "484px",
      observations:
        "Rich Media donde se puede elegir entre dos opciones divididas por un cross-slider.",
    },
    {
      title: "Selector de partes",
      category: "Todos",
      link: "https://369.ad/mediakit/CFMoto-320x480/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Anuncio de un modelo de vehiculo donde se puede conocer las diferentes caratcerísticas para generar awareness de dicho modelo, resaltando sus atributos, acompañado de videos de cada parte.",
    },
    {
      title: "Selector de Modelos",
      category: "Todos",
      link: "https://369.ad/mediakit/audi-selector/index.html",
      sizes: "300x600, 320x480",
      height: "484px",
      observations:
        "Rich Media de selector de modelos de distintos tipos de vehiculos.",
    },
    {
      title: "Selector de Colores",
      category: "Todos",
      link: "https://369.ad/mediakit/fiat/index.html",
      sizes: "300x600, 320x480",
      height: "484px",
      observations:
        "Rich Media de selector de colores del mismo modelo de vehiculos.",
    },
    {
      title: "Blackjack",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/Blackjack/Blackjack/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Rich Media simulador de una partida de Blackjack para ganar y avanzar a la página web.",
    },
    {
      title: "Paint Roller",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/Paint-wall/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Rich Media que consiste en pintar la pared con distintos colores, enfocado a empresas de pintura.",
    },
  ],
  gamingAndGambling: [
    {
      title: "Brackets",
      category: "Gaming y Gambling",
      link: "https://369.ad/mediakit/landing-rich-medias/cup-brackets/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Brackets de torneo deportivo para hacer predicciones del ganador y continuar luego al sitio web a traves del botón de Call to Action.",
    },
    {
      title: "Poker",
      category: "Gaming y Gambling",
      link: "https://369.ad/mediakit/landing-rich-medias/poker/poker/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Partida de Poker en la que te encontrás en la mano antes del último flop, apostás all-in y terminás ganando, para continuar a la página.",
    },
    {
      title: "Ruleta",
      category: "Gaming y Gambling",
      link: "https://369.ad/mediakit/landing-rich-medias/roulette/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Ruleta de casino en la que hacés click en el boton y ganás para continuar a la página web.",
    },
    {
      title: "Live Odds",
      category: "Gaming y Gambling",
      link: "https://369.ad/mediakit/landing-rich-medias/live-odds/live-odds/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Rich media que utiliza APIs para obtener información en tiempo real de estadísticas de partidos y el usuario elige el cuadro que cree va a ganar.",
    },
    {
      title: "Blackjack",
      category: "Gaming y Gambling",
      link: "https://369.ad/mediakit/landing-rich-medias/Blackjack/Blackjack/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Rich Media simulador de una partida de Blackjack para ganar y avanzar a la página web.",
    },
    {
      title: "Aviador",
      category: "Gaming y Gambling",
      link: "https://369.ad/mediakit/landing-rich-medias/avion/avion/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Rich Media con el objetivo de hacer click cuando el avión pase por el logo de tu empresa.",
    },
  ],

  finance: [
    {
      title: "Scratch and Reveal",
      category: "Financiero",
      link: "https://369.ad/mediakit/atlas-scratch/index.html",
      sizes: "300x600, 320x480",
      height: "484px",
      observations:
        "Anuncio de raspar y revelar un premio o beneficio del otro lado.",
    },
    {
      title: "Calculadora de préstamos",
      category: "Financiero",
      link: "https://369.ad/mediakit/landing-rich-medias/prestamo/prestamo/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Calculadora de préstamos donde ingresás el monto a solicitar, los meses a pagar y el anuncio te dirá cuanto se debe pagar de intereses por mes.",
    },
    {
      title: "Planes",
      category: "Financiero",
      link: "https://369.ad/mediakit/landing-rich-medias/Planes-320X480/Planes-320X480/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Rich Media para financieras donde se ofrece al cliente distintos planes con beneficios dependiendo del plan.",
    },
    {
      title: "Ruleta",
      category: "Financiero",
      link: "https://369.ad/mediakit/landing-rich-medias/roulette/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Ruleta de casino en la que hacés click en el boton y ganás para continuar a la página web.",
    },
    {
      title: "Cubo",
      category: "Financiero",
      link: "https://369.ad/mediakit/Crediton-cubo/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Cubo 3D giratorio para colocar 4 imágenes distintas sobre tu empresa/producto.",
    },
    {
      title: "Scratch and Reveal",
      category: "Financiero",
      link: "https://369.ad/mediakit/landing-rich-medias/En-la-mano-scratch/En-la-mano-scratch/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Anuncio de raspar y revelar un premio o beneficio del otro lado.",
    },
  ],

  retail: [
    {
      title: "Vertical scroller",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/adidas/adidas/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Rich Media para seleccionar y desplazarse entre distintos productos.",
    },
    {
      title: "Memory",
      category: "Retail",
      link: "https://369.ad/mediakit/imperial-memory/index.html",
      sizes: "300x600, 320x480",
      height: "484px",
      observations:
        "Juego de Memory clásico en el que tenés que unir las mismas imagenes para luego pasar al botón de Call to Action.",
    },
    {
      title: "Inbanner",
      category: "Retail",
      link: "https://369.ad/mediakit/brahma-inbanner/index.html",
      sizes: "300x600, 320x480",
      height: "484px",
      observations: "Rich Media con reproductor de video para eventos y demás.",
    },
    {
      title: "Whatsapp Rich Media",
      category: "Retail",
      link: "https://369.ad/mediakit/budweiser_whatsapp/index.html",
      sizes: "300x600, 320x480",
      observations: "Rich Media que conecta con un contacto de Whatsapp.",
    },
    {
      title: "Cubo",
      category: "Retail",
      link: "https://369.ad/mediakit/stella-artois-cubo/index.html",
      sizes: "300x600, 320x480",
      height: "484px",
      observations:
        "Cubo 3D giratorio para colocar 4 imágenes distintas sobre tu empresa/producto.",
    },
    {
      title: "Scratch and Reveal",
      category: "Retail",
      link: "https://369.ad/mediakit/corona-scratch/index.html",
      sizes: "300x600, 320x480",
      height: "484px",
      observations:
        "Anuncio de raspar y revelar un premio o beneficio del otro lado.",
    },

    {
      title: "Drink Frost",
      category: "Retail",
      link: "https://369.ad/mediakit/landing-rich-medias/Fernet-branca/Fernet-branca/index.html",
      sizes: "300x600, 320x480",
      height: "484px",
      observations:
        "Rich Media con el objetivo de hacer click repetidas veces en el mismo, para que cada vez se genere mas escarcha, destinado a bebidas o productos de consumo frios.",
    },
    {
      title: "Scratch and Reveal",
      category: "Retail",
      link: "https://369.ad/mediakit/landing-rich-medias/Scratch-Te/Scratch-Te/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Anuncio de raspar y revelar un premio o beneficio del otro lado.",
    },
    {
      title: "Creador de sandwich",
      category: "Retail",
      link: "https://369.ad/mediakit/landing-rich-medias/Bimbo/Bimbo/index.html",
      sizes: "300x600, 320x480",
      height: "484px",
      observations:
        "Anuncio destinado principalmente a empresas de comida, en este caso elegir tus condimentos preferidos para tu sandwich preferido.",
    },
    {
      title: "Weather",
      category: "Retail",
      link: "https://369.ad/mediakit/nestle320x480/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Anuncio donde a través de una API se muestra la temperatura de un lugar determinado, destinado, por ejemplo, a empresas de heeladería.",
    },
  ],
  automotive: [
    {
      title: "Aviador",
      category: "Automotriz",
      link: "https://369.ad/mediakit/landing-rich-medias/avion/avion/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Rich Media con el objetivo de hacer click cuando el avión pase por el logo de tu empresa.",
    },
    {
      title: "Cross Slider",
      category: "Automotriz",
      link: "https://369.ad/mediakit/cross-slider-shell/index.html",
      sizes: "300x600, 320x480",
      height: "484px",
      observations:
        "Rich Media donde se puede elegir entre dos opciones divididas por un cross-slider.",
    },
    {
      title: "Selector de partes",
      category: "Automotriz",
      link: "https://369.ad/mediakit/CFMoto-320x480/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Anuncio de un modelo de vehiculo donde se puede conocer las diferentes caratcerísticas para generar awareness de dicho modelo, resaltando sus atributos, acompañado de videos de cada parte.",
    },
    {
      title: "Selector de Modelos",
      category: "Automotriz",
      link: "https://369.ad/mediakit/audi-selector/index.html",
      sizes: "300x600, 320x480",
      height: "484px",
      observations:
        "Rich Media de selector de modelos de distintos tipos de vehiculos.",
    },
    {
      title: "Slider",
      category: "Automotriz",
      link: "https://369.ad/mediakit/bmw-gallery/index.html",
      sizes: "300x600, 320x480",
      height: "484px",
      observations:
        "Slides de distintos productos para hacer click en el que elijas.",
    },
    {
      title: "Memory",
      category: "Automotriz",
      link: "https://369.ad/mediakit/landing-rich-medias/audimemory/audimemory/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Juego de Memory clásico en el que tenés que unir las mismas imagenes para luego pasar al botón de Call to Action.",
    },
    {
      title: "Selector de Colores",
      category: "Automotriz",
      link: "https://369.ad/mediakit/fiat/index.html",
      sizes: "300x600, 320x480",
      height: "484px",
      observations:
        "Rich Media de selector de colores del mismo modelo de vehiculos.",
    },
    {
      title: "Cubo",
      category: "Automotriz",
      link: "https://369.ad/mediakit/geely/index.html",
      sizes: "300x600, 320x480",
      height: "484px",
      observations:
        "Cubo 3D giratorio para colocar 4 imágenes distintas sobre tu empresa/producto.",
    },
  ],
  beauty: [
    {
      title: "Clock",
      category: "Todos",
      link: "https://369.ad/mediakit/clock/index.html",
      sizes: "300x600, 320x480",
      height: "484px",
      observations: "Rich Media que cuenta con un reloj adquirido de una API.",
    },
    {
      title: "Scratch and Reveal",
      category: "Todos",
      link: "https://369.ad/mediakit/ralph-lauren-scratch/index.html",
      sizes: "300x600, 320x480",
      height: "484px",
      observations:
        "Anuncio de raspar y revelar un premio o beneficio del otro lado.",
    },
    {
      title: "Before and After",
      category: "Todos",
      link: "https://369.ad/mediakit/lancome-video/index.html",
      sizes: "300x600, 320x480",
      height: "484px",
      observations:
        "Rich Media con gif e imagenes de antes y después para productos de belleza, acompañado de un botón CTA.",
    },
    {
      title: "Clock",
      category: "Todos",
      link: "https://369.ad/mediakit/reloj-crema-solar/index.html",
      sizes: "300x600, 320x480",
      height: "484px",
      observations: "Rich Media que cuenta con un reloj adquirido de una API.",
    },
    {
      title: "Scratch and Reveal",
      category: "Todos",
      link: "https://369.ad/mediakit/lancome-scratch/index.html",
      sizes: "300x600, 320x480",
      height: "484px",
      observations:
        "Anuncio de raspar y revelar un premio o beneficio del otro lado.",
    },
  ],
  others: [
    {
      title: "Selector",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/Accuracy-bipod-selector/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Rich Media para seleccionar entre diferentes productos, ver su detalle y hacer click en comprar.",
    },
    {
      title: "Slider",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/Bipod-acuracy-slide/Bipod-acuracy-slide/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Slides de distintos productos para hacer click en el que elijas.",
    },
    {
      title: "Unir los puntos",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/real-state/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Unir los puntos en orden para dibujar una forma en el anuncio, una vez unidos todos los puntos, aparece una imagen a gusto.",
    },
    {
      title: "Reproductor MP3",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/MP3/MP3/index.html",
      sizes: "300x600, 320x480",
      observations: "Anuncio de reproductor musical con distintas pistas.",
    },
    {
      title: "Paint Roller",
      category: "Todos",
      link: "https://369.ad/mediakit/landing-rich-medias/Paint-wall/index.html",
      sizes: "300x600, 320x480",
      observations:
        "Rich Media que consiste en pintar la pared con distintos colores, enfocado a empresas de pintura.",
    },
  ],
};
